var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('qnb',{staticClass:"d-block",attrs:{"user-id":_vm.userId,"user-token":_vm.userToken,"value":_vm.totalValue,"saveids":_vm.paymentIds}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }